import React, { Component } from "react";
import FoundationTestRunner from "../components/test/FoundationTestRunner";
import { getFoundationStudent } from "../foundationSession";
import "../theme/_fdn-theme.scss";

const TESTS_PATH = "/student/iit-foundation-course/tests";
const ERROR_PATH = "/student/iit-foundation-course/error-exams";
const CREATE_PATH = "/iit-foundation/create-exam";

/**
 * Full-screen take-test page (its own route, not a modal).
 *
 * Chapter is passed through the URL query string so the page survives a refresh:
 *   /iit-foundation/take-test?chapter=<id>&subject=<id>&name=<chapter name>
 * class_id and registration_id come from the in-memory/session student.
 */
class IITFoundationTakeTest extends Component {
  back = () => {
    const params = new URLSearchParams(
      (this.props.location && this.props.location.search) || window.location.search
    );
    const mode = params.get("mode");
    const dest = mode === "error" ? ERROR_PATH : mode === "custom" ? CREATE_PATH : TESTS_PATH;
    const { history } = this.props;
    if (history) history.push(dest);
    else window.location.assign(dest);
  };

  render() {
    const student = getFoundationStudent() || {};
    const params = new URLSearchParams(
      (this.props.location && this.props.location.search) || window.location.search
    );
    const mode = params.get("mode");
    const isError = mode === "error";
    const isCustom = mode === "custom";
    const chapterId = params.get("chapter");
    const subjectId = params.get("subject");
    const chapterName = params.get("name") || (isError ? "Error Exam" : isCustom ? "Custom Exam" : "Test");
    const toIds = (v) => (v ? v.split(",").map((x) => x.trim()).filter(Boolean) : []);
    let topics = [];
    try { topics = JSON.parse(params.get("topics") || "[]"); } catch (e) { topics = []; }

    if (!student || student.grade_id == null) {
      return (
        <div className="ftest-page fdn-theme">
          <div className="ftest-empty ftest-state">
            <div className="ftest-state-icon"><i className="fas fa-user-lock" /></div>
            <h4>Hold on! 🔐</h4>
            <p>Please log in to take a test.</p>
            <button className="ftest-btn fdn-btn fdn-btn--blue fdn-btn--lg" onClick={() => this.back()}><i className="fas fa-arrow-left" /> Back to tests</button>
          </div>
        </div>
      );
    }
    if (!isError && !isCustom && !chapterId) {
      return (
        <div className="ftest-page fdn-theme">
          <div className="ftest-empty ftest-state">
            <div className="ftest-state-icon"><i className="fas fa-book-open" /></div>
            <h4>Oops! 🤔</h4>
            <p>No chapter selected.</p>
            <button className="ftest-btn fdn-btn fdn-btn--blue fdn-btn--lg" onClick={() => this.back()}><i className="fas fa-arrow-left" /> Back to tests</button>
          </div>
        </div>
      );
    }

    return (
      <FoundationTestRunner
        mode={isError ? "error" : isCustom ? "custom" : "chapter"}
        chapterId={chapterId}
        chapterName={chapterName}
        classId={student.grade_id != null ? student.grade_id : null}
        subjectId={subjectId != null ? subjectId : null}
        subjectIds={toIds(params.get("subjects"))}
        chapterIds={toIds(params.get("chapters"))}
        topics={topics}
        registrationId={student.id != null ? student.id : null}
        onClose={this.back}
      />
    );
  }
}

export default IITFoundationTakeTest;
